import { forwardRef } from 'react';
import classNames from 'classnames';

const CheckboxField = forwardRef(({ field, value, onChange, style, markStyle = 'tick' }, ref) => {
  const isChecked = value === true || value === 'true' || value === 'Yes';

  const handleClick = () => {
    onChange(field.name, !isChecked);
  };

  // Fixed tick size for all checkboxes — consistent appearance regardless of box size
  const markSize = 14;

  return (
    <div
      ref={ref}
      className={classNames('pdf-checkbox-field', `mark-${markStyle}`, { checked: isChecked })}
      onClick={handleClick}
      style={{
        position: 'absolute',
        ...style,
        cursor: 'pointer',
        border: style.border || (markStyle === 'auto' ? 'none' : '1px solid #666'),
        backgroundColor: markStyle === 'auto' ? 'transparent' : '#fff',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin: 0,
        overflow: 'hidden'
      }}
    >
      {isChecked && markStyle === 'tick' && <span style={{ fontSize: `${markSize}px`, fontWeight: 'bold', lineHeight: 1 }}>✓</span>}
      {isChecked && markStyle === 'cross' && <span style={{ fontSize: `${markSize}px`, fontWeight: 'bold', lineHeight: 1 }}>✗</span>}
      {isChecked && markStyle === 'circle' && <span style={{ fontSize: `${markSize}px`, fontWeight: 'bold', lineHeight: 1 }}>●</span>}
      {/* For 'auto' style, don't render any mark - let PDF native field show through */}
    </div>
  );
});

CheckboxField.displayName = 'CheckboxField';

export default CheckboxField;
